import { AiSuggestedComponentProps } from 'redux/schemas/models/ai-course-creation';
import { ComponentType, LectureComponent } from 'redux/schemas/models/lecture-component';
import { Poll } from 'redux/schemas/models/poll';

const PollQuestion = ({ componentSet }: AiSuggestedComponentProps) => {
  const activity = componentSet.activity as LectureComponent<ComponentType.POLL>;
  // here the type is PollNormalized, We are not normalizing the components
  // for suggest activities. so Cast the poll to the correct type
  const poll = activity.poll as unknown as Poll;

  return (
    <>
      {poll.questions.map((question) => (
        <div
          className='d-flex flex-column mt-4'
          key={question.type}
        >
          <div className='text-lg-bold mb-2'>{question.questionText}</div>
          <ul className='mb-0'>
            {question.responseOptions.map((option) => (
              <li
                className='text-large-body'
                key={option.optionContent}
              >
                {option.optionContent}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </>
  );
};

export default PollQuestion;
